import request from "../utils/request"

export function fetchAiImageWorkspace(folderId) {
  return request({ url: "/office/ai-images/workspace", method: "get", params: folderId ? { folderId } : {} })
}

export function fetchAiImageConfig() {
  return request({ url: "/office/ai-images/config", method: "get" })
}

export function saveAiImageConfig(data) {
  return request({ url: "/office/ai-images/config", method: "put", data })
}

export function testAiImageConfig(data) {
  return request({ url: "/office/ai-images/config/test", method: "post", data, timeout: 60000 })
}

export function createAiImageFolder(data) {
  return request({ url: "/office/ai-images/folders", method: "post", data })
}

export function updateAiImageFolder(folderId, data) {
  return request({ url: `/office/ai-images/folders/${folderId}`, method: "put", data })
}

export function deleteAiImageFolder(folderId) {
  return request({ url: `/office/ai-images/folders/${folderId}`, method: "delete" })
}

export function createAiImageTask(data) {
  return request({ url: "/office/ai-images/tasks", method: "post", data })
}

export function moveAiImage(imageId, folderId) {
  return request({ url: `/office/ai-images/images/${imageId}/folder`, method: "patch", data: { folderId } })
}

export function deleteAiImage(imageId) {
  return request({ url: `/office/ai-images/images/${imageId}`, method: "delete" })
}

export function attachAiImage(imageId, data) {
  return request({ url: `/office/ai-images/images/${imageId}/attach`, method: "post", data, timeout: 120000 })
}

